/**
 * Created by Alan Yang on 7/19/17.
 * Description:
 *
 * ------ maintenance history ------
 * 05/06/2019 Yoyo add action and feedback subject
 */

import { AppConfig } from '../models/app-config.model';
import { Subject } from 'rxjs';
export enum EntityListActionType {
    RELOAD = 'RELOAD',
}

export class EntityListAction {
    constructor(
        public type: EntityListActionType,
        public payload: any) {
    }
}

export enum EntityListFeedbackType {
    VIEW_READY = 'ENTITIES_VIEW',
    DONE_RELOAD = 'ENTITIES_DONE_RELOAD',
    SELECTED = 'ENTITIES_SELECTED'
}

export class EntityListFeedBack {
    constructor(
        public type: EntityListFeedbackType,
        public payload: any) {
    }
}

export class EntityListConfig {
    public bufferSize: number = AppConfig.threadListPageBufferSize;
    public actionSubject: Subject<EntityListAction>;
    public feedbackSubject: Subject<EntityListFeedBack>;
    // For smart reducer - public prefix:string;
    constructor(
        public rootSelector: string,
        public keywordField: string = null,
        public instanceId: string = null,
        public hideKeyword: boolean = false) {
        this.actionSubject = new Subject<EntityListAction>();
        this.feedbackSubject = new Subject<EntityListFeedBack>();
    }
}
